import React from 'react';

import { style, keyframes } from 'glamor';

import { RED } from 'depop/styles/colors';

const bounce = keyframes('bounce', {
  // optional name
  '0%': { transform: 'translateX(0)' },
  '50%': { transform: 'translateX(2rem)' },
  '100%': { transform: 'translateX(0)' },
});

export default () =>
  <div
    {...style({
      position: 'relative',
      width: '3rem',
      height: '3rem',
      margin: '20px auto',
      overflow: 'hidden',
    })}>
    <div
      {...style({
        animationName: bounce,
        animationDuration: '1s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'ease-in-out',
        background: RED,
        width: '1rem',
        height: '1rem',
        position: 'absolute',
        top: '1rem',
        left: 0,
        borderRadius: '50%',
      })}
    />
  </div>;



// WEBPACK FOOTER //
// ../src/client/components/loaders/Ball.js